<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="natures-patients">
<h1>Natures’ Patients</h1>
<p style="text-indent:0px;">Take a look around and see,</p>
<p style="text-indent:0px;">Our Earth is crying from our greed.</p>
<p style="text-indent:0px;">Whether it be the anger of a tree,</p>
<p style="text-indent:0px;">Or no rain when we are in desperate need.</p><br/>
<p style="text-indent:0px;">We were given undeserving life,</p>
<p style="text-indent:0px;">However it came to exist.</p>
<p style="text-indent:0px;">We have caused our own strife,</p>
<p style="text-indent:0px;">The point of living, it has been missed.</p><br/>
<p style="text-indent:0px;">You can only live in harmony,</p>
<p style="text-indent:0px;">If both sides for upon peace they decide.</p>
<p style="text-indent:0px;">The side of breathing anatomy,</p>
<p style="text-indent:0px;">They did not abide.</p><br/>
<p style="text-indent:0px;">We taught ourselves to conjure flame,</p>
<p style="text-indent:0px;">Then came to use the wheel.</p>
<p style="text-indent:0px;">We took wild animals to tame,</p>
<p style="text-indent:0px;">Empires arose, then we began to steal.</p><br/>
<p style="text-indent:0px;">Blood filled, battles raged,</p>
<p style="text-indent:0px;">Throughout our tainted history.</p>
<p style="text-indent:0px;">Brother’s battles for territory engaged,</p>
<p style="text-indent:0px;">Causing taxation clashing misery.</p><br/>
<p style="text-indent:0px;">Modern humans refined technology,</p>
<p style="text-indent:0px;">Making it easier to kill.</p>
<p style="text-indent:0px;">Borders now built out of hostility,</p>
<p style="text-indent:0px;">Just to witness bank accounts refill.</p><br/>
<p style="text-indent:0px;">Lines were drawn on a map,</p>
<p style="text-indent:0px;">Cultures emerged in different form.</p>
<p style="text-indent:0px;">Blood drips like a leaking tap,</p>
<p style="text-indent:0px;">This is now the norm.</p><br/>
<p style="text-indent:0px;">Nature has been watching,</p>
<p style="text-indent:0px;">While we try to control her sunlit source.</p>
<p style="text-indent:0px;">Since we started trying,</p>
<p style="text-indent:0px;">This cannot be done of course.</p><br/>
<p style="text-indent:0px;">Our life-bearing patient mother,</p>
<p style="text-indent:0px;">Is becoming increasingly disturbed.</p>
<p style="text-indent:0px;">Until we learn to love each other,</p>
<p style="text-indent:0px;">We shall remain in pain deserved.</p><br/>
<p style="text-indent:0px;">We must see now that nature is getting angry,</p>
<p style="text-indent:0px;">We were once beings so divine.</p>
<p style="text-indent:0px;">We cannot let her make us hungry,</p>
<p style="text-indent:0px;">We need a new apologetic guideline.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch012.vue?4a32f752